module.exports = __webpack_public_path__ + "static/media/homeImage.46b96eb3.png";